import React from 'react';
import { Chip } from '@material-ui/core';
import { FILE_NODE_CATEGORY, FILE_TYPE_COLORS, FORMAT_COLORS } from 'Utils/fileTypeUtils';

// DatasourceType (FILE_*_FOLDER) → human label. FileNodeType values (CSV, TSV,
// PARQUET, …) render as-is — the all-caps three-to-seven-letter form is already
// readable and matches what the directory tree shows next to each file.
// UNKNOWN gets a human label too: it means "no/unrecognized extension", and the
// raw enum name reads like an error rather than an honest "we can't tell from
// the name" (the content-sniffed verdict lives in the Detected column).
const DATASOURCE_TYPE_LABELS = {
  FILE_DELIMITED_FOLDER: 'Delimited',
  FILE_PARQUET_FOLDER: 'Parquet',
  FILE_DOCUMENT_FOLDER: 'Document',
  FILE_JSON_FOLDER: 'JSON',
  FILE_XML_FOLDER: 'XML',
  FILE_EXCEL_FOLDER: 'Excel',
  FILE_FIXED_WIDTH_FOLDER: 'Fixed width',
  FIXED_WIDTH: 'Fixed width',
  FILE_HL7_FOLDER: 'HL7',
  HL7: 'HL7',
  FILE_EDI_FOLDER: 'EDI',
  EDI: 'EDI',
  // Display-only type for the sniffer's "readable text, format unrecognized"
  // fallback (see displaySniffType in Utils/fileTypeUtils).
  TEXT: 'Text',
  UNKNOWN: 'Unidentified',
};

const FileTypeChip = ({ type }) => {
  if (!type) return null;
  const category = FILE_NODE_CATEGORY[type] || 'archive';
  const bg = FORMAT_COLORS[type] || FILE_TYPE_COLORS[category];
  const label = DATASOURCE_TYPE_LABELS[type] || type;
  return (
    <Chip
      size='small'
      label={label}
      style={{
        backgroundColor: bg,
        color: '#fff',
        fontFamily: 'Rubik',
        fontWeight: 500,
        height: 18,
        borderRadius: 999,
        textTransform: 'uppercase',
        letterSpacing: '0.03em',
        fontSize: 11,
      }}
    />
  );
};

export default FileTypeChip;
